import { render } from "./InfoContact.vue?vue&type=template&id=f7aa5e4e"
import script from "./InfoContact.vue?vue&type=script&lang=js"
export * from "./InfoContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__